import { OptionalDatePicker } from "components/DatePicker/OptionalDatePicker";
import moment from "moment";
import React from "react";
import { FreefieldInPageEditInputProps } from "shared/utils/freeFields/models";
import { isFreeFieldDateEmpty } from "shared/utils/freeFields/utils";

const FFInPageEditOptionalDatePicker = (props: FreefieldInPageEditInputProps) => {
  const [date, setDate] = React.useState(!isFreeFieldDateEmpty(props.value) ? moment.utc(props.value) : undefined);

  const onDateChange = (date: moment.Moment, submit?: boolean) => {
    setDate(date);
    props.onChange(date ? date.toISOString() : undefined, submit);
  };

  return <OptionalDatePicker
    focusOnMount
    validatorKey={`freefield${props.reference}`}
    minDate={moment(serverReference.constants.appointment.minDate)}
    maxDate={moment(serverReference.constants.appointment.maxDate)}
    value={date}
    onChange={onDateChange}
    onEnter={() => props.submit()}
    onEsc={() => props.cancel()}
  />;
};

export default FFInPageEditOptionalDatePicker;